import { type ReactNode, useEffect, useState } from 'react';
import classnames from 'classnames';
import styles from './index.module.less';
import { TabGroup, type TabItem } from '../tab-group';
import Element from '../../../core/Element';

interface TabGroupWithContentProps {
  data: {
    content: ReactNode;
    ariaLabelledBy: string;
    id: string;
    qeId: string;
  }[];
  activeIndex: number;
  tabItems: TabItem[];
  onTabIndexChange?: (i: number) => void;
  autoActivation?: boolean;
  shouldStayHorizontal?: boolean;
  qeId?: string;
}

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please migrate to the new Tabs V2 when possible.
 */
export const TabGroupWithContent = ({
  data,
  activeIndex = 0,
  tabItems,
  onTabIndexChange = () => {},
  autoActivation,
  shouldStayHorizontal,
  qeId,
}: TabGroupWithContentProps) => {
  const [currentIndex, setCurrentIndex] = useState<number>(activeIndex);
  useEffect(() => {
    setCurrentIndex(activeIndex);
  }, [activeIndex]);

  return (
    <Element>
      <TabGroup
        autoActivation={autoActivation}
        qeId={`TabGroupWithContent-${qeId}`}
        activeIndex={currentIndex}
        onIndexChange={(_tabState, i) => {
          onTabIndexChange(i);
          setCurrentIndex(i);
        }}
        data={{ tabItems }}
        shouldStayHorizontal={shouldStayHorizontal}
      />
      {data.map(({ content, ariaLabelledBy, id, qeId }, i) => (
        <Element
          className={classnames(styles.tabPanel, {
            [styles.showTabPanel]: i === currentIndex,
          })}
          aria-labelledby={ariaLabelledBy}
          role="tabpanel"
          id={id}
          key={`tabpanel-${qeId}-${i}`}
          tabIndex={0}
          qeId={qeId}
        >
          {content}
        </Element>
      ))}
    </Element>
  );
};
